var map = {
	"./amio/amio-card-image.json": 20,
	"./amio/amio.json": 47,
	"./canos/canos-card-image.json": 21,
	"./canos/canos.json": 48,
	"./hyren/hyren-card-image.json": 22,
	"./hyren/hyren.json": 49,
	"./xenos/xenos-card-image.json": 23,
	"./xenos/xenos.json": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;